import { createContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { node } from 'prop-types';

export const HistoryCounterContext = createContext();

const HistoryCounter = ({ children }) => {
  const history = useHistory();

  const [historyCounter, setHistoryCounter] = useState(0);

  useEffect(() => {
    const onHistoryChanged = (_, action) => {
      if (action === 'PUSH') {
        if (historyCounter < 0) {
          setHistoryCounter(1);
        } else {
          setHistoryCounter(historyCounter + 1);
        }
      } else if (action === 'POP') {
        setHistoryCounter(historyCounter - 1);
      }
    };

    const unlistenHistory = history.listen(onHistoryChanged);
    return () => {
      unlistenHistory();
    };
  }, [history, historyCounter]);
  return (
    <HistoryCounterContext.Provider value={historyCounter}>
      {children}
    </HistoryCounterContext.Provider>
  );
};

HistoryCounter.propTypes = {
  children: node,
};

export default HistoryCounter;
